import PlanCard from './PlanCard';
import React from "react";

const PlanCardList = ({
  plans,
  handleSelectPlan,
  updateSubscriptionLoading,
  isHiddenOrCustomPlan
}) => {
  return (
    <div className='plan-card-list'>
      {
        plans.map((plan, index) => {
          return (
            <div style={{ margin: '0px 5px' }} key={index}>
              <PlanCard
                plan={plan}
                handleSelectPlan={handleSelectPlan}
                updateSubscriptionLoading={updateSubscriptionLoading}
                isHiddenOrCustomPlan={isHiddenOrCustomPlan}
              />
            </div>
          )
        })
      }
    </div>
  );
}

export default PlanCardList;